import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import NavRouting from "./component/NavRouting";
import "./App.css";
import { SwalProvider } from "./services/SweetAlert";

function App() {
  return(
  <SwalProvider>   
    <NavRouting />
  </SwalProvider>
  )
}
export default App;
